import { render, staticRenderFns } from "./statInfo.vue?vue&type=template&id=74976440&scoped=true"
import script from "./statInfo.vue?vue&type=script&lang=js"
export * from "./statInfo.vue?vue&type=script&lang=js"
import style0 from "./statInfo.vue?vue&type=style&index=0&id=74976440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74976440",
  null
  
)

export default component.exports